(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("PIXI"));
	else if(typeof define === 'function' && define.amd)
		define(["PIXI"], factory);
	else if(typeof exports === 'object')
		exports["AVG"] = factory(require("PIXI"));
	else
		root["AVG"] = factory(root["PIXI"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_18__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition